import React, { useState, useEffect } from 'react'

import HoverTooltip from '../../../../../../components/HoverTooltip'
import MoneyInput from '../../../../../../components/form/MoneyInput'
import CurrencySelector from '../../../../../../components/currency/CurrencySelector'
import CurrencyExchangeRateInput from '../../../../../../components/currency/CurrencyExchangeRateInput'

import Section from '../../../../../../components/Section'
import {
    Contract,
    ContractPerformance,
    LongTermContractVolumes,
} from '../../../types'

import { CurrencyList } from '../../../../Plans/Positions/Edit/types'

import {
    purchaseTypeInfo,
    purchaseInfo,
    planInfo,
    ContractConfirmingDocsError,
} from '../types'

import Checkbox from '../../../../../../components/form/Checkbox'
import ContractConfirmingDocsTable from './ContractTable/ContractConfirmingDocsTable'

import { ContractConfirmingDoc } from '../../../types'

type Props = {
    theme: string
    contractAction: boolean
    contractGuid: string | undefined
    contract: Contract
    errors?: ContractConfirmingDocsError
    contractConfirmDocs: ContractConfirmingDoc | null
    onConfirmDocs: (confirm_docs: ContractConfirmingDoc | null) => void
}

const ContractConfirmingDocs: React.FC<Props> = (props) => {
    return (
        <Section title="Основание для заключения договора">
            <fieldset disabled={props.contractAction}>
                <div className="flex flex-col w-full gap-3 items-start justify-start ">
                    <ContractConfirmingDocsTable
                        theme={props.theme}
                        contractAction={props.contractAction}
                        contractGuid={props.contractGuid}
                        contract={props.contract}
                        errors={props.errors}
                        onConfirmDocs={props.onConfirmDocs}
                        contractConfirmDocs={props.contractConfirmDocs}
                    />
                </div>
            </fieldset>
        </Section>
    )
}

export default ContractConfirmingDocs
